import { createContext, useContext } from 'react';
/**
 * @internal
 */
export var NestedContext = /*#__PURE__*/createContext(undefined);
export var useNestedContext = function useNestedContext() {
  var context = useContext(NestedContext);
  if (!context) {
    var error = '';
    if (process.env.NODE_ENV === 'development') {
      error = "\nTo use a <NestingItem /> it needs to be a descendant of <NestableNavigationContent>.\nYou probably need to replace your <NavigationContent> with <NestableNavigationContent>.\n\nimport { NestableNavigationContent } from '@atlaskit/side-navigation';\n      ";
    }
    throw new Error(error);
  }
  return context;
};

/**
 * Used by children of the NestableNavigationContent component to see if they should render or not.
 * If `shouldRender` returns `true` - return your nodes.
 * If it returns `false` - either return `null` or `children` if you have children.
 */
export var useShouldNestedElementRender = function useShouldNestedElementRender() {
  var context = useContext(NestedContext);
  if (!context) {
    return {
      shouldRender: true
    };
  }
  return {
    shouldRender: context.currentStackId === context.parentId
  };
};